/**
 * The resource namespace.
 */
export const defaultNS = "mum.qualitygate.web";